<template>
  <div class="rescue">
    <BackTop></BackTop>
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">威马捷健康管理俱乐部</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle">威马捷健康管理俱乐部-全球紧急救援服务卡《吉安卡》</h3>
      <p class="experience-para">威马捷健康管理俱乐部为服务更多的全球出行人员，将公司三大优势资源，即专业的救援客服中心，广泛的全球合作网络及丰富的医疗转运经验，有机整合后，以全球紧急救援服务卡的形式回馈给新老客户。</p>
      <p class="experience-para">全球紧急救援服务卡不同于其他高利润的捆绑式销售的保险附带救援服务，而是以透明化的会员服务费及实报实销的治疗救援费为基础，每位客户只需缴纳很少的会员管理费即可成为威马捷健康管理俱乐部的一员，在案件发生时享受价值1万元～5万元的救援服务内容。</p>
      <p class="experience-para">加入会员没有年龄限制，也无关是否购买过保险，无论您是以个人形式，家庭形式、企业形式或其他集体形式均可加入。</p>
      <h4 class="rescue-title">服务卡介绍</h4>
      <div class="experience-part">
        <div class="club-list">
          <div class="club-cell ">
            <h5 class="club01">365*24小时的专业救援客服中心</h5>
            <ul>
              <li>经验丰富的救援客服人员</li>
              <li>高品质的业务管理，客户满意度分析</li>
              <li>专家医生的第二诊疗意见</li>
              <li>住院治疗监护及治疗费用管理</li>
            </ul>
          </div>
          <div class="club-cell">
            <h5 class="club02">广泛的全球合作网络资源</h5>
            <ul>
              <li>超过13,000家的医院合作网络</li>
              <li>超过2,800家的供应商合作网络（包括世界各地的医疗包机公司，救援公司，殡仪馆，翻译人员等）</li>
            </ul>
          </div>
          <div class="club-cell">
            <h5 class="club03">优秀的案件管理系统及全球联网呼叫中心系统</h5>
            <ul>
              <li>全球11个救援中心（中、日、泰、新、英、美、加、法）组成的服务平台</li>
              <li>年呼入电话数超过200,000通</li>
              <li>年提供救援服务超过67,000件</li>
            </ul>
          </div>
          <div class="club-cell">
            <h5 class="club04">丰富的医疗转运经验积累</h5>
            <ul>
              <li>超过2000件的转运案例数据收录及经验总结</li>
              <li>独自开发的转运地图系统</li>
              <li>航空医学专业医生的转运意见</li>
              <li>经验丰富的转运医护团队</li>
            </ul>
          </div>
          <div class="club-cell">
            <h5 class="club05">透明的收费与服务</h5>
            <ul>
              <li>无隐形收费，无虚高收费，无回扣</li>
              <li>透明的服务项目与统一收费标准</li>
              <li>会员专享的优惠（免费）服务项目</li>
            </ul>
          </div>
          <div class="club-cell">
            <h5 class="club06">会员信息专享</h5>
            <ul>
              <li>定期更新健康管理相关文章</li>
              <li>定期推荐国内外优秀医疗资源</li>
              <li>根据会员需求提供专属信息</li>
            </ul>
          </div>
        </div>

      </div>
      <h4 class="rescue-title">威马捷全球健康俱乐部</h4>
      <div class="experience-part">
        <div class="global-card">
          <div class="card-box">
            <div class="card-tab tab01">
              <h5>威马捷健康管理俱乐部</h5>
              <h4>EA Card （安心・安全）</h4>
              <p>⊱ Plus ⊰</p>
              <ul>
                <li>会员号码：EA12345678</li>
                <li>有效期限：自激活日起1年</li>
                <li>会员姓名：Ji Aｎ</li>
              </ul>
            </div>
            <p class="club-quantity">=价值
              <span>5万元</span>的紧急救援服务内容</p>
          </div>
          <div class="card-box">
            <div class="card-tab tab02">
              <h5>威马捷健康管理俱乐部</h5>
              <h4>EA Card （安心・安全）</h4>
              <ul>
                <li>会员号码：EA12345678</li>
                <li>有效期限：自激活日起1年</li>
                <li>会员姓名：Ji Aｎ</li>
              </ul>
            </div>
            <p class="club-quantity">=价值
              <span>1万元</span>的紧急救援服务内容</p>
          </div>
        </div>
        <table class="other-service">
          <thead>
            <tr>
              <th>服务项目</th>
              <th>服务内容</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>緊急移送/<br/>帰国搬送救援服务</td>
              <td>24小时客服中心提供的医疗转运操作，包括医疗信息确认，顾问医生见解，转运计划的制定，预约转运交通工具，安排转运陪同医护人员，协助预约转运目的地接受医院等实际转运安排</td>
            </tr>
            <tr>
              <td>遗体火葬/<br/>遗体或遗骨归国转运</td>
              <td>提供当地殡仪馆信息，介绍现地遗体处理及转运相关手续，如有需要可介绍现地工作人员陪同办理手续。协助联系国内殡仪馆接收遗体。</td>
            </tr>
            <tr>
              <td>介绍医疗结构（24H）<br/>介绍医疗翻译</td>
              <td>24小时客服中心提供所在地的医院、医生的名称、地址和电话，被保险人根据自己的需要自主选择医疗机构就医。可根据会员需要介绍专业翻译人员。 提供当地最新的免疫及疫苗注射信息
              </td>
            </tr>
            <tr>
              <td>住院期间病情监控</td>
              <td>实时监控患者在现地的治疗及费用情况。 取得医疗信息并由威马捷顾问医生给出病情评估（第一次免费） 医疗信息翻译并给家属提供报告。
              </td>
            </tr>
            <tr>
              <td>在线医疗咨询服务</td>
              <td>如会员有医疗咨询需求，可通过微信服务号与顾问医生进行沟通。每次疾患咨询期为3天不超过10个问题，全年不超过5次。</td>
            </tr>
            <tr>
              <td>紧急信息传递</td>
              <td>会员在中国境内外旅行期间发生意外或突发急性病时，威马捷按会员的要求将情况尽快通知其亲属。</td>
            </tr>
            <tr>
              <td>緊急移送/<br/>帰国搬送救援服务</td>
              <td>24小时客服中心提供的医疗转运操作，包括医疗信息确认，顾问医生见解，转运计划的制定，预约转运交通工具，安排转运陪同医护人员，协助预约转运目的地接受医院等实际转运安排</td>
            </tr>
            <tr>
              <td>遗体火葬/<br/>遗体或遗骨归国转运</td>
              <td>提供当地殡仪馆信息，介绍现地遗体处理及转运相关手续，如有需要可介绍现地工作人员陪同办理手续。协助联系国内殡仪馆接收遗体。</td>
            </tr>
          </tbody>
        </table>
        <p class="experience-para">※会员卡自激活日开始一年有效期，在到期日前可办理续费延期。</p>
        <p class="experience-para">※会员卡有效期内如需追缴合同范围外的服务内容可享受会员专属价格。</p>
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/assets/images/rescue/service1.jpg'
export default {
  data () {
    return {
      service
    }
  },
  mounted () {

  }
}
</script>
<style lang="less" scoped>
.club-list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  flex-wrap: wrap;
  .club-cell {
    width: 400px;
    min-height: 246px;
    border: 1px solid #ccc;
    padding: 10px;
    margin-bottom: 20px;
    h5 {
      font-size: 24px;
      color: #ae1e10;
      line-height: 40px;
      background-size: 40px auto;
      background-repeat: no-repeat;
      background-position: left top;
      text-indent: 50px;
    }
    .club01 {
      background-image: url('../assets/images/home/icon-service1.png');
    }
    .club02 {
      background-image: url('../assets/images/home/icon-service2.png');
    }
    .club03 {
      background-image: url('../assets/images/home/icon-service3.png');
    }
    .club04 {
      background-image: url('../assets/images/home/icon-service4.png');
    }
    .club05 {
      background-image: url('../assets/images/home/icon-service5.png');
    }
    .club06 {
      background-image: url('../assets/images/home/icon-service6.png');
    }
    ul {
      li {
        list-style-position: inside;
        list-style-type: disc;
        font-size: 20px;
        color: #333130;
        line-height: 36px;
      }
    }
  }
}
.global-card,
.card-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.global-card {
  padding: 0 20px;
}
.card-tab {
  width: 340px;
  height: 237px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 20px;
  margin-right: 20px;
  h5 {
    font-size: 14px;
    color: #333130;
    line-height: 24px;
  }
  h4 {
    font-size: 24px;
    color: #333130;
    line-height: 56px;
  }
  ul li {
    font-size: 14px;
    color: #333130;
    line-height: 20px;
  }
}
.tab01 {
  background: url('../assets/images/rescue/club1.png') no-repeat center;
  background-size: 100% auto;
}
.tab02 {
  background: url('../assets/images/rescue/club2.png') no-repeat center;
  background-size: 100% auto;
}
.club-quantity {
  width: 90px;
  font-size: 20px;
  color: #333130;
  line-height: 30px;
  span {
    color: #ae1e10;
  }
}
.other-service {
  width: 884px;
  margin: 20px auto;
  tr {
    th {
      background: #be5150;
      color: #fff;
      font-size: 26px;
      line-height: 80px;
      border: 2px solid #fff;
    }
    td {
      &:first-child {
        width: 268px;
        font-size: 24px;
        color: #242424;
        text-align: center;
      }
      &:last-child {
        font-size: 20px;
        color: #242424;
        line-height: 36px;
        padding: 16px;
      }
    }
  }
  tbody {
    tr {
      &:nth-child(odd) {
        background: #e7d0d0;
      }
      &:nth-child(even) {
        background: #f4e9e9;
      }
      td {
        border: 2px solid #fff;
      }
    }
  }
}
</style>